import { createContext, ReactNode, useContext, useEffect, useState } from 'react';

import { Config } from '../models/config';
import { ConfigService } from '../services';
import { reportHandledError } from '../../frontendObservability';

interface ConfigProps {
  config?: Config;
}

const ConfigContext = createContext<ConfigProps>({});

export const ConfigProvider = ({ children }: { children: ReactNode }) => {
  const [config, setConfig] = useState<ConfigProps['config']>();

  useEffect(() => {
    const fetchData = async () => setConfig(await ConfigService.getConfig());
    fetchData().catch(error => reportHandledError(error, {
      bundle: 'master-app-ui',
      component: 'ConfigProvider',
      operation: 'load-config',
    }));
  }, []);

  return <ConfigContext.Provider value={{ config }}>{children}</ConfigContext.Provider>;
};

export function useConfig(): ConfigProps {
  return useContext(ConfigContext);
}
